import * as React from "react";
import { connect } from "react-redux";
import { getUnpaidOrders } from "../../app/store/actions/whFinanceActions";
import { useEffect, useMemo, useState } from "react";
import { formatDisplayId } from "../../app/components/AntTableStyles";
import { FoCard, FoChips, FoSearch, FoTable, formatEgp, statusBadge } from "./financeUi";

const courierOf = (order) => {
  if (order.blinkTrackingId || order.blinkId) return "Blink";
  if (order.bostaTrackingId || order.bostaId) return "Bosta";
  if (order.fincartId || order.fincartCode) return order.fincartCourier || "Fincart";
  if (order.shipbluTrackingId || order.shipbluId) return "Shipblu";
  if (order.courierTrackingId) return "Courier";
  return "—";
};

export const UnpaidOrders = ({ getUnpaidOrders, orders, isLoading }) => {
  const [status, setStatus] = useState("All");
  const [query, setQuery] = useState("");

  useEffect(() => {
    getUnpaidOrders({});
  }, []);

  const rows = useMemo(
    () =>
      (Array.isArray(orders) ? orders : []).map((order) => ({
        _id: order._id,
        order,
        trackingId: order.courierTrackingId || order.shipbluTrackingId || order.bostaTrackingId || order.blinkTrackingId || order.fincartCode || "—",
        vendorName: order.vendor?.brandName || order.vendor?.name || "—",
        courier: courierOf(order),
        price: order.price,
        financeStatus: order.chainzFinanceStatus || "Pending",
      })),
    [orders]
  );

  const filtered = rows.filter((row) => {
    const statusOk = status === "All" || row.order.status === status;
    const needle = query.trim().toLowerCase();
    if (!needle) return statusOk;
    const haystack = `${row._id} ${row.trackingId} ${row.vendorName} ${row.courier}`.toLowerCase();
    return statusOk && haystack.includes(needle);
  });

  const columns = [
    { title: "Order ID", dataIndex: "_id", render: (value) => <span className="fo-mono">{formatDisplayId(value)}</span> },
    { title: "Brand", dataIndex: "vendorName" },
    { title: "Tracking", dataIndex: "trackingId" },
    { title: "Courier", dataIndex: "courier" },
    { title: "Order value", dataIndex: "price", render: (value) => `${formatEgp(value)} EGP`, sorter: (a, b) => (a.price || 0) - (b.price || 0) },
    { title: "Order status", dataIndex: ["order", "status"], render: (_, row) => statusBadge(row.order.status) },
    { title: "Finance", dataIndex: "financeStatus", render: (value) => statusBadge(value === "Paid" ? "Paid" : "Unpaid") },
  ];

  return (
    <div className="fo-stack">
      <div className="fo-tools">
        <FoChips
          value={status}
          onChange={setStatus}
          options={["All", "Delivered", "Returned", "Returned to Chainz"]}
        />
        <FoSearch value={query} onChange={setQuery} placeholder="Search order, tracking, or brand..." />
      </div>
      <FoCard title="Unpaid orders" count={`${filtered.length} orders`}>
        <FoTable
          columns={columns}
          dataSource={filtered}
          loading={isLoading}
          empty="No unpaid orders in this view."
          pagination={{ pageSize: 10, total: filtered.length }}
        />
      </FoCard>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  orders: state?.records?.orders,
});

const mapDispatchToProps = { getUnpaidOrders };

export default connect(mapStateToProps, mapDispatchToProps)(UnpaidOrders);
